import {
    CQuoteFeesDataResponse,
} from 'app/requests/CQuote/CQuote.requests'
import {
    RequestConfigFunction,
} from 'app/types/request.types'

type SimplifiedCQuotesRequests = {
    filterRequest: RequestConfigFunction<Record<string, any>>,
    get: RequestConfigFunction<{ id: number }>,
    update: RequestConfigFunction<{ id: number }>,
    generateSimplifiedCQuote: RequestConfigFunction<any>,
    getFeesData: RequestConfigFunction<{ params: any }, CQuoteFeesDataResponse>,
}

const request: SimplifiedCQuotesRequests = {
    generateSimplifiedCQuote: (params) => {
        return {
            url: 'simplifiedquote/generate',
            data: {
                ...params,
            },
            method: 'POST',
        }
    },
    getFeesData: (params) => {
        return {
            url: 'simplifiedquote/fees-data',
            data: {
                ...params,
            },
            method: 'POST',
        }
    },
    filterRequest: (params = {}) => {
        return {
            url: 'simplifiedquote/filter-request/all',
            method: 'POST',
            ...params,
        }
    },
    get: ({
        id,
    }: { id: number }) => {
        return {
            url: `simplifiedquote/${id}`,
            method: 'GET',
        }
    },
    update: ({
        id,
    }: { id: number }) => {
        return {
            url: `simplifiedquote/${id}`,
            method: 'PATCH',
        }
    },
}

export default request
